export const DEFAULT_USER_AGENT = window?.navigator.userAgent || '';

export enum DeviceInfoPlatform {
  Android = 'android',
  Huawei = 'huawei',
  Web = 'web',
  Ios = 'ios',
  Safari = 'safari',
  Desktop = 'desktop',
}

export const platformInfo = {
  deviceId: '',
  platform: DeviceInfoPlatform.Web,
  device: 'unsupported',
  osName: '',
  osVersion: '-1',
  isSafari: false,
  isFF: false,
  isChrome: false,
  isElectron: false,
  isMobile: false,
  isTablet: false,
};
